{
  "version": 1,
  "asset_id": "64beada3-9b52-4c60-8cb9-d6e19958b351",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/64beada3-9b52-4c60-8cb9-d6e19958b351/sleeve-to-bypass-completed-en-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/64beada3-9b52-4c60-8cb9-d6e19958b351/sleeve-to-bypass-completed-en-320.webp",
  "original_filename": "sleeve-to-bypass-completed-en-320.webp",
  "size": 13538,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:46:20Z"
}
